import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

interface ContentBlock {
  type: string;
  content: string;
  image_url?: string;
  image_alt?: string;
  sequence?: number;
}

interface ContentBlocksDisplayProps {
  contentBlocks: ContentBlock[];
  maxBlocks?: number;
  showFullContent?: boolean;
}

const ContentBlocksDisplay: React.FC<ContentBlocksDisplayProps> = ({
  contentBlocks,
  maxBlocks = 1,
  showFullContent = false
}) => {
  const theme = useTheme();
  
  if (!contentBlocks || contentBlocks.length === 0) {
    return null;
  }

  // Sort blocks by sequence
  const sortedBlocks = [...contentBlocks].sort((a, b) => (a.sequence || 0) - (b.sequence || 0));
  
  // Limit blocks for preview
  const displayBlocks = showFullContent ? sortedBlocks : sortedBlocks.slice(0, maxBlocks);
  
  // Find the first text block
  const firstTextBlock = sortedBlocks.find(block => block.type === 'text');

  return (
    !showFullContent ?(
      <Box sx={{ mt: 2 }}>
        <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
        <Box sx={{ mb: 2 }}>
          {firstTextBlock ? (
            <Typography
              variant="body2"
              sx={{
                // lineHeight: 1.6,
                // color: theme.palette.text.primary,
                ...(showFullContent ? {} : {
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: '-webkit-box',
                  WebkitLineClamp: 10,
                  WebkitBoxOrient: 'vertical'
                })
              }}
            >
              <div 
                // eslint-disable-next-line @typescript-eslint/naming-convention
                dangerouslySetInnerHTML={{ __html: firstTextBlock.content }}
              />
            </Typography>
          ) : null}
          {!showFullContent && contentBlocks.length > maxBlocks && (
          <Typography
            variant="body2"
            sx={{ 
              cursor: 'pointer',
              fontStyle: 'italic',
              color: theme.palette.primary.main,
              '&:hover': { 
                textDecoration: 'underline',
                color: theme.palette.primary.dark
              }
            }}
          >
            +{contentBlocks.length - 1} more blocks
          </Typography>
        )}
        </Box>
        </Typography>
      </Box>
    ):(
    <Box sx={{ mt: 2 }}>
      {displayBlocks.map((block, index) => (
        <Box key={index} sx={{ mb: 2 }}>
          {block.type === 'text' ? (
            <Typography
              variant="body2"

            >
              <div 
                // eslint-disable-next-line @typescript-eslint/naming-convention
                dangerouslySetInnerHTML={{ __html: block.content }}
              />
            </Typography>
          ) : block.type === 'image' && block.image_url ? (
            <Box sx={{ mt: 1 }}>
                              <img
                  src={block.image_url}
                  alt={block.image_alt || 'Content image'}
                  style={{
                    width: '100%',
                    maxHeight: 400,
                    objectFit: 'cover',
                    borderRadius: theme.shape.borderRadius
                  }}
                />
              {block.image_alt && (
                <Typography
                  variant="caption"
                  sx={{ 
                    mt: 0.5, 
                    display: 'block', 
                    fontStyle: 'italic',
                    color: theme.palette.text.secondary
                  }}
                >
                  {block.image_alt}
                </Typography>
              )}
            </Box>
          ) : null}
        </Box>
      ))}
    
    </Box>
  )

  );
};

export default ContentBlocksDisplay; 